/* eslint-disable react/jsx-props-no-spreading */
import React from 'react';
import PropTypes from 'prop-types';

import { AuthProvider } from '@navigation/middlewares';
import { BasicLayout } from '@navigation/layouts';

/**
 * Route Page Component
 *
 * @component
 * @param {Object} params - Component params
 * @param {Object} params.route - Route configuration
 * @example
 * const route = {
 *    name: "LOGIN",
 *    path: "/login",
 *    canActivate: ["ADMIN"],
 *    showOnNav: false,
 *    component: <Component/>,
 *  };
 * return (
 *  <Page route={route}/>
 * )
 */
const Page = ({ route, ...rest }) => {
  const PageBody = route.component;
  const Layout = route.layout ? route.layout : BasicLayout;
  const layoutProps = route.layoutProps ? route.layoutProps : {};
  return (
    <AuthProvider route={route}>
      <Layout route={route} {...{ ...rest, ...layoutProps }}>
        <PageBody route={route} {...rest} />
      </Layout>
    </AuthProvider>
  );
};

Page.propTypes = {
  route: PropTypes.shape({
    title: PropTypes.string,
    layout: PropTypes.any,
    layoutProps: PropTypes.object,
    name: PropTypes.string.isRequired,
    path: PropTypes.string.isRequired,
    showOnNav: PropTypes.bool.isRequired,
    component: PropTypes.any.isRequired,
  }).isRequired,
};

export default Page;
